import { baseApiUrl } from './global'
import axios from 'axios'
import store from '@/store'
import router from '@/router'

const axiosInstance = axios.create({
  baseURL: baseApiUrl,
  withCredentials: true,
})

axiosInstance.interceptors.request.use((config) => {
  const currentRoute = router.currentRoute?.value
  const matchedRoutes = Array.isArray(currentRoute?.matched) ? currentRoute.matched : []
  const screenPath = matchedRoutes.length > 0 ? matchedRoutes[matchedRoutes.length - 1]?.path : currentRoute?.path

  if (screenPath) {
    config.headers['x-screen-path'] = screenPath
  }

  if (currentRoute?.path) {
    config.headers['x-screen-current-path'] = currentRoute.path
  }

  return config
})

axiosInstance.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (error.response) {
      if (error.response.status === 401) {
        localStorage.clear()
        store.dispatch('setError', {
          message: 'Sessão expirada, direcionando para página de login.',
        })
        localStorage.setItem('user', null)
        window.location.href = '/login'
        // window.location.href = `${deployPath}/login`
        store.dispatch('setError', {
          message: error.response.data.message || 'An error occurred',
        })
      } else if (error.response.status === 403) {
        store.dispatch('setError', {
          message: error.response.data.message || 'An error occurred',
        })
      }
    }
    return Promise.reject(error)
  }
)

export default axiosInstance
